import ReportsContainer from './reports_container';

const Reports = ReportsContainer;
export default Reports;
